import React from "react";
import './student-answered-status-board.scss';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";




class StudentAnsweredStatusBoard extends React.Component {


    state = {
        //         studentsList : [
        //   { studentNumber: 1, userName: "Arun", receivedAnswer: true },
        //   { studentNumber: 2, userName: "Priya", receivedAnswer: true },
        //   { studentNumber: 3, userName: "Karthik", receivedAnswer: true },
        //   { studentNumber: 4, userName: "Divya", receivedAnswer: true },
        //   { studentNumber: 5, userName: "Vijay", receivedAnswer: true },
        //   { studentNumber: 6, userName: "Sneha", receivedAnswer: true },
        //   { studentNumber: 7, userName: "Rahul", receivedAnswer: true },
        //   { studentNumber: 8, userName: "Meena", receivedAnswer: true },
        //   { studentNumber: 9, userName: "Suresh", receivedAnswer: false },
        //   { studentNumber: 10, userName: "Anitha", receivedAnswer: false },

        //   { studentNumber: 11, userName: "Ravi", receivedAnswer: true },
        //   { studentNumber: 12, userName: "Kavya", receivedAnswer: true },
        //   { studentNumber: 13, userName: "Manoj", receivedAnswer: true },
        //   { studentNumber: 14, userName: "Deepa", receivedAnswer: true },
        //   { studentNumber: 15, userName: "Ajay", receivedAnswer: true },
        //   { studentNumber: 16, userName: "Pooja", receivedAnswer: true },
        //   { studentNumber: 17, userName: "Naveen", receivedAnswer: true },
        //   { studentNumber: 18, userName: "Lakshmi", receivedAnswer: true },
        //   { studentNumber: 19, userName: "Santhosh", receivedAnswer: false },
        //   { studentNumber: 20, userName: "Rekha", receivedAnswer: false },

        //   { studentNumber: 21, userName: "Arun", receivedAnswer: true },
        //   { studentNumber: 22, userName: "Priya", receivedAnswer: true },
        //   { studentNumber: 23, userName: "Karthik", receivedAnswer: true },
        //   { studentNumber: 24, userName: "Divya", receivedAnswer: true },
        //   { studentNumber: 25, userName: "Vijay", receivedAnswer: true },
        //   { studentNumber: 26, userName: "Sneha", receivedAnswer: true },
        //   { studentNumber: 27, userName: "Rahul", receivedAnswer: true },
        //   { studentNumber: 28, userName: "Meena", receivedAnswer: true },
        //   { studentNumber: 29, userName: "Suresh", receivedAnswer: false },
        //   { studentNumber: 30, userName: "Anitha", receivedAnswer: false },

        //   { studentNumber: 31, userName: "Ravi", receivedAnswer: true },
        //   { studentNumber: 32, userName: "Kavya", receivedAnswer: true },
        //   { studentNumber: 33, userName: "Manoj", receivedAnswer: true },
        //   { studentNumber: 34, userName: "Deepa", receivedAnswer: true },
        //   { studentNumber: 35, userName: "Ajay", receivedAnswer: true },
        //   { studentNumber: 36, userName: "Pooja", receivedAnswer: true },
        //   { studentNumber: 37, userName: "Naveen", receivedAnswer: true },
        //   { studentNumber: 38, userName: "Lakshmi", receivedAnswer: true },
        //   { studentNumber: 39, userName: "Santhosh", receivedAnswer: false },
        //   { studentNumber: 40, userName: "Rekha", receivedAnswer: false },

        //   { studentNumber: 41, userName: "Arun", receivedAnswer: true },
        //   { studentNumber: 42, userName: "Priya", receivedAnswer: true },
        //   { studentNumber: 43, userName: "Karthik", receivedAnswer: true },
        //   { studentNumber: 44, userName: "Divya", receivedAnswer: true },
        //   { studentNumber: 45, userName: "Vijay", receivedAnswer: true },
        //   { studentNumber: 46, userName: "Sneha", receivedAnswer: true },
        //   { studentNumber: 47, userName: "Rahul", receivedAnswer: true },
        //   { studentNumber: 48, userName: "Meena", receivedAnswer: true },
        //   { studentNumber: 49, userName: "Suresh", receivedAnswer: false },
        //   { studentNumber: 50, userName: "Anitha", receivedAnswer: false },

        //   { studentNumber: 51, userName: "Ravi", receivedAnswer: true },
        //   { studentNumber: 52, userName: "Kavya", receivedAnswer: true },
        //   { studentNumber: 53, userName: "Manoj", receivedAnswer: true },
        //   { studentNumber: 54, userName: "Deepa", receivedAnswer: true },
        //   { studentNumber: 55, userName: "Ajay", receivedAnswer: true },
        //   { studentNumber: 56, userName: "Pooja", receivedAnswer: true },
        //   { studentNumber: 57, userName: "Naveen", receivedAnswer: true },
        //   { studentNumber: 58, userName: "Lakshmi", receivedAnswer: true },
        //   { studentNumber: 59, userName: "Santhosh", receivedAnswer: false },
        //   { studentNumber: 60, userName: "Rekha", receivedAnswer: false }
        // ],
        studentsList: this.props.studentList,
        hoveredStudent: null

    }






    children = ({ remainingTime }) => {
        const minutes = Math.floor(remainingTime / 60)
        const seconds = remainingTime % 60

        return `${minutes}:${seconds}`
    }


    addExtraSeconds() {
        this.props.delegate && this.props.delegate.startExtraCountDown && this.props.delegate.startExtraCountDown()
    }

    renderSmallStatusBar() {
        return (
            <div className="student-answered-status-board">
                <div className='timer-wrapper'>
                    <div className=''>
                        <CountdownCircleTimer
                            size={100}
                            trailColor='#1CEA24'
                            isPlaying={this.props.isPlaying}
                            duration={this.props.questionTime}
                            colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                            colorsTime={[10, 6, 3, 0]}
                            onComplete={() => ({ shouldRepeat: false, delay: 1 }, this.addExtraSeconds())}
                        >
                            {(remainingTime) => (
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                    <div className="timer-text">
                                        {this.children(remainingTime)}
                                    </div>
                                    {
                                        !this.props.isPlaying ?
                                            <div className="">
                                                <img className="pause-button-image-size" src={getImageSource(ImageConstants.PAUSE_BUTTON)} />
                                            </div>
                                            :
                                            <></>
                                    }

                                </div>
                            )}

                        </CountdownCircleTimer>
                    </div>
                </div>
                <div className="d-flex justify-content-center align-items-center button-wrapper mt-4">
                    {
                        this.state.studentsList && this.state.studentsList.length ?
                            this.state.studentsList.map(student => (
                                student.isTeacher ? <></> :
                                    <div className={`student-roll-number-button ml-1 mb-1 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}</div>
                            ))
                            :
                            <>No Students Found</>
                    }
                </div>
            </div>
        )
    }

    handleMouseEnter = (studentNumber) => {
        this.setState({ hoveredStudent: studentNumber });
    };

    handleMouseLeave = () => {
        this.setState({ hoveredStudent: null });
    };

    getTextWidth(text, font = '28px Arial') {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font; // Set font (must match your usage)
        console.log(context.measureText(text).width)
        return context.measureText(text).width; // Width in pixels
    }

    renderLargeStatusBar() {

        // console.log(this.state.studentsList)

        return (
            <div className="large-student-answered-status-board-clicker-assessment">

                {/* {
                    !this.props.isReadOnly ?

                        <div className='timer-wrapper'>
                            <div className=''>
                                <CountdownCircleTimer
                                    size={10}
                                    trailColor='#FFFFFF'
                                    isPlaying={this.props.isPlaying}
                                    duration={this.props.questionTime}
                                    colors={["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"]}
                                    colorsTime={[10, 6, 3, 0]}
                                    onComplete={() => ({ shouldRepeat: false, delay: 1 }, this.addExtraSeconds())}
                                >
                                    {(remainingTime) => (
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            <div className="timer-text">
                                                {this.children(remainingTime)}
                                            </div>
                                            {
                                                !this.props.isPlaying ?
                                                    <div className="">
                                                        <img className="pause-button-image-size" src={getImageSource(ImageConstants.PAUSE_BUTTON)} />
                                                    </div>
                                                    :
                                                    <></>
                                            }

                                        </div>
                                    )}

                                </CountdownCircleTimer>
                            </div>
                        </div>
                        :
                        <></>
                } */}
                <div className="d-flex align-items-center button-wrapper">
                    {
                        this.state.studentsList && this.state.studentsList.length ?
                            this.state.studentsList.map(student => (
                                student.isTeacher ? <></> :
                                    <div className="position-relative" onMouseEnter={() => this.handleMouseEnter(student.studentNumber)}
                                        onMouseLeave={this.handleMouseLeave}>

                                        <div className="cursor-pointer" onMouseEnter={() => this.handleMouseEnter(student.studentNumber)}
                                            onMouseLeave={this.handleMouseLeave}>
                                            {
                                                this.props.isReadOnly ?
                                                    <div
                                                        className={`student-roll-number-button ml-1 mb-1 ${student.receivedAnswer && student.isCorrect ? 'enable-button' :
                                                            student.receivedAnswer && !student.isCorrect ? "incorrect-button" : 'not-answered-button'}`}>{student.studentNumber}
                                                    </div>
                                                    :
                                                    <div
                                                        className={`student-roll-number-button ml-1 mb-1 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}
                                                    </div>
                                            }
                                        </div>
                                        {/* <div className={`student-roll-number-button ml-1 mb-1 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}</div> */}
                                        {this.state.hoveredStudent === student.studentNumber && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "-50px", // Align at the bottom
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    fontSize: "28px",
                                                    color: "white",
                                                    zIndex: '999999',
                                                    width: this.getTextWidth(student.userName) + 30
                                                }}
                                                className="student-name"
                                            >
                                                {student.userName}
                                            </div>
                                        )}
                                    </div>

                            ))
                            :
                            <>No Students Found</>
                    }
                </div>
            </div>
        )
    }


    render() {

        console.log(this.props.showLargeStudentResponseSideBar)



        return (
            <div>
                {
                    this.props.isFFF || this.props.showLargeStudentResponseSideBar ?

                        this.renderLargeStatusBar()
                        :
                        this.renderSmallStatusBar()

                }
            </div>
        )



    }

}

export default StudentAnsweredStatusBoard;